// extracted by mini-css-extract-plugin
module.exports = {"heading":"payroll-screen_heading__3PG1o","title":"payroll-screen_title__10ywd"};